(function () {
  var CFG = {
    handle: 'vitamin-supplement-drops',
    texto: 'Regalo',
    reglas: [
      { v: 59069954720008, min: 2 },
      { v: 59069954752776, min: 3 }
    ]
  };

  function esRegalo(it) {
    return !!(it && it.properties && it.properties._regalo);
  }

  function config(url) {
    var c = typeof fetchConfig === 'function' ? fetchConfig(url) : { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' } };
    return c;
  }

  async function sincronizar(el) {
    if (!el.cart || el.__vitSincronizando) return false;
    el.__vitSincronizando = true;
    try {
      var items = el.cart.items || [];
      var q = items.filter(function (it) { return it.handle === CFG.handle && !esRegalo(it); }).reduce(function (n, it) { return n + it.quantity; }, 0);
      var anadir = [];
      var updates = {};
      CFG.reglas.forEach(function (r) {
        var lineas = items.filter(function (it) { return it.variant_id === r.v && esRegalo(it); });
        var toca = q >= r.min;
        if (toca && !lineas.length) anadir.push({ id: r.v, quantity: 1, properties: { _regalo: '1' } });
        lineas.forEach(function (l, i) {
          var quiero = toca && i === 0 ? 1 : 0;
          if (l.quantity !== quiero) updates[l.key] = quiero;
        });
      });
      var ids = CFG.reglas.map(function (r) { return r.v; });
      items.forEach(function (it) {
        var esVariante = ids.indexOf(it.variant_id) !== -1;
        if ((esRegalo(it) && !esVariante) || (esVariante && !esRegalo(it))) updates[it.key] = 0;
      });
      if (!anadir.length && !Object.keys(updates).length) return false;
      var base = (window.routes && window.routes.cart_url) || '/cart';
      if (Object.keys(updates).length) {
        await fetch(base + '/update.js', Object.assign({}, config('json'), { body: JSON.stringify({ updates: updates }) }));
      }
      if (anadir.length) {
        await fetch((window.routes && window.routes.cart_add_url) || '/cart/add', Object.assign({}, config('javascript'), { body: JSON.stringify({ items: anadir }) }));
      }
      var r = await fetch(base + '.js');
      el.cart = await r.json();
      if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') publish(PUB_SUB_EVENTS.cartUpdate, { source: 'vitalce-carrito', cartData: el.cart });
      return true;
    } catch (e) {
      return false;
    } finally {
      el.__vitSincronizando = false;
    }
  }

  function decorar(el) {
    var items = (el.cart && el.cart.items) || [];
    el.querySelectorAll('[data-lista] [data-key]').forEach(function (li) {
      var it = items.find(function (x) { return x.key === li.dataset.key; });
      if (!esRegalo(it)) return;
      var cant = li.querySelector('.vit-cart__cant');
      if (cant) {
        var chip = document.createElement('span');
        chip.className = 'vit-cart__chip';
        chip.style.alignSelf = 'flex-start';
        chip.style.textTransform = 'uppercase';
        chip.textContent = CFG.texto;
        cant.replaceWith(chip);
      }
      var borrar = li.querySelector('.vit-cart__borrar');
      if (borrar) borrar.remove();
      var tier = li.querySelector('.vit-cart__tier');
      if (tier) tier.remove();
    });
  }

  function parchear() {
    var C = customElements.get('vitalce-carrito');
    if (!C) return false;
    if (C.prototype.__vitRegalos) return true;
    C.prototype.__vitRegalos = true;
    var pintarOriginal = C.prototype.pintar;
    C.prototype.refrescar = async function () {
      try {
        var r = await fetch(((window.routes && window.routes.cart_url) || '/cart') + '.js');
        this.cart = await r.json();
        await sincronizar(this);
        await this.pintar();
      } catch (e) {}
    };
    C.prototype.pintar = async function () {
      await pintarOriginal.call(this);
      decorar(this);
    };
    return true;
  }

  if (!parchear()) {
    customElements.whenDefined('vitalce-carrito').then(function () {
      parchear();
      var el = document.querySelector('vitalce-carrito');
      if (el && el.lista) el.refrescar();
    });
  }
})();
